import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-externalsurvey',
  templateUrl: './externalsurvey.component.html',
  styleUrls: ['./externalsurvey.component.scss']
})
export class ExternalsurveyComponent implements OnInit {

  urlexternal: any = null;
  urlexternal2: any = null;
  bridge: any = null;
  visible: boolean = false;
  constructor(
    private actRoute: ActivatedRoute,
    private domSanitizer: DomSanitizer) { }

  ngOnInit() {
    this.urlexternal = this.domSanitizer.bypassSecurityTrustResourceUrl('https://ee.kobotoolbox.org/single/HsQhSwNL');
    this.urlexternal2 = this.domSanitizer.bypassSecurityTrustResourceUrl('https://ee.kobotoolbox.org/single/hQx5a9lm');

    const params = this.actRoute.snapshot.params;
    this.bridge = this.urlexternal2;
    this.visible = true;
    if (params['url']) {
      if (params['url'] === "encuesta-externa-riesgos-2022") {
        this.bridge = this.urlexternal;
        this.visible = true;
      } else if (params['url'] === "encuesta-externa-oportunidades-2022") {
        this.bridge = this.urlexternal2;
        this.visible = true;
      }
    }
  }

}

